import { AppTour } from '../tour.model';

export const TAX_RATE_INTRO_TOUR: AppTour = {
  tourId: 'tax-rate-intro-tour',
  showProgress: false,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: 'tax-rate-function-intro-tour',
      attachTo: { element: '#function-guide-20', on: 'right' },
      cancelIcon: {enabled: false},
      title: 'tour_setup_tax_intro_title',
      text: 'tour_setup_tax_intro_text',
       buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onSkipClick' },
        { text: 'tour_label_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onSetupClick'}
      ]
    }
  ]};


export const TAX_RATE_WIZARD_TOUR: AppTour = {

  tourId: 'tax-rate-wizard-tour',
  showProgress: true,
  useModalOverlay: true,
  autoResume: false,
  defaultStepOptions: { scrollTo: true },
  steps: [
    {
      id: 'tax-rate-wizard-step1-tour',
      attachTo: { element: '#step-guide-1', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_setup_tax_wizard_step1_title',
      text: 'tour_setup_tax_wizard_step1_text',
      buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onStep1SkipClick' },
        { text: 'tour_label_setup_tax', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onStep1SetupClick'}
       ]
     },
     {
      id: 'tax-rate-wizard-step2-tour',
      attachTo: { element: '#step-guide-2', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_setup_tax_wizard_step2_title',
      text: 'tour_setup_tax_wizard_step2_text',
      buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onStep2SkipClick' },
        { text: 'tour_label_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onStep2SetupClick'}
       ]
     },
    {
      id: 'tax-rate-wizard-step3-tour',
      attachTo: { element: '#step-guide-3', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_setup_tax_wizard_step3_title',
      text: 'tour_setup_tax_wizard_step3_text',
      buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onStep3SkipClick' },
        { text: 'tour_label_setup', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onStep3SetupClick'}
       ]
     },
    {
      id: 'tax-rate-wizard-step4-tour',
      attachTo: { element: '#step-guide-4', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_setup_tax_wizard_step4_title',
      text: 'tour_setup_tax_wizard_step4_text',
      buttons: [
        { text: 'tour_label_skip', action: 'custom',className:"btn btn-primary-tertiary btn-primary-tertiary--sm",handlerKey: 'onStep4SkipClick' },
        { text: 'tour_label_assign_tax', action: 'custom', className:"btn btn-primary btn-primary--sm",handlerKey: 'onStep4SetupClick'}
       ]
     }   
   ]
};

export const SETUP_TAX_PANEL_TOGGLE_TOUR: AppTour = {

  tourId: 'setup-tax-panel-toggle-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: false, classes: 'tooltip-guide' },
  steps: [
    {
      id: 'turn-on-off-tax-setup-tour',
      attachTo: { element: '#turn-on-off-tax-setup-guide', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_setup_tax_toggle_title',
      text: 'tour_setup_tax_toggle_text',
      parallel: true
     }
   ]
};

export const SETUP_TAX_PANEL_SAVE_TOUR: AppTour = {

  tourId: 'setup-tax-panel-save-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: false, classes: 'tooltip-guide' },
  steps: [
    {
      id: 'btn-save-tax-setup-tour',
      attachTo: { element: '#btn-save-tax-setup-guide', on: 'bottom' },
      cancelIcon: {enabled: false},
      title: 'tour_setup_tax_save_title',
      text: 'tour_setup_tax_save_text',
      parallel: true
     }
   ]
};

export const SETUP_TAX_NAME_METHOD_PANEL_TOUR: AppTour = {

  tourId: 'setup-tax-name-method-panel-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: false, classes: 'tooltip-guide' },
  steps: [
    {
      id: 'tax-name-tour',
      attachTo: { element: '#tax-name-guide', on: 'bottom-start' },
      cancelIcon: {enabled: false},
      title: 'tour_setup_tax_name_method_title',
      text: 'tour_setup_tax_name_method_text',
      parallel: true
     }
   ]
};


export const SETUP_TAX_RATES_CODES_PANEL_TOUR: AppTour = {

  tourId: 'setup-tax-rates-codes-panel-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: false, classes: 'tooltip-guide' },
  steps: [
    {
      id: 'btn-edit-tax-rate-code-tour',
      attachTo: { element: '.btn-edit-ag-grid-guide', on: 'bottom-start' },
      cancelIcon: {enabled: false},
      title: 'tour_setup_tax_code_title',
      text: 'tour_setup_tax_code_text',
      parallel: true
     }
   ]
};


export const ASSIGN_TAX_TO_CATEGORIES_PANEL_TOUR: AppTour = {

  tourId: 'assign-tax-to-categories-panel-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: false, classes: 'tooltip-guide' },
  steps: [
    {
      id: 'chk-select-assign-tax-to-categories-tour',
      attachTo: { element: '.chk-ag-grid-guide', on: 'bottom-start' },
      cancelIcon: {enabled: false},
      title: 'tour_assign_tax_to_categories_title',
      text: 'tour_assign_tax_to_categories_text',
      parallel: true
     }
   ]
};


export const SELECT_TAX_CATEGORY_TOUR: AppTour = {

  tourId: 'select-tax-category-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: false, classes: 'tooltip-guide' },
  steps: [
    {
      id: "select-tax-category-tour",
      attachTo: { element: '#select-tax-category-guide', on: 'bottom-start' },
      cancelIcon: {enabled: false},
      title: 'tour_select_tax_category_title',
      text: 'tour_select_tax_category_text',
      parallel: true
     }
   ]
};

export const ASSIGN_TAX_CATEGORY_TOUR: AppTour = {

  tourId: 'assign-tax-category-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: false, classes: 'tooltip-guide' },
  steps: [
    {
      id: "assign-tax-category-tour",
      attachTo: { element: '#btn-assign-tax-category-guide', on: 'bottom-start' },
      cancelIcon: {enabled: false},
      title: 'tour_assign_tax_category_title',
      text: 'tour_assign_tax_category_text',
      parallel: true
     }
   ]
};

export const SAVE_TAX_CATEGORY_TOUR: AppTour = {

  tourId: 'save-tax-category-tour',
  showProgress: false,
  useModalOverlay: false,
  autoResume: false,
  defaultStepOptions: { scrollTo: false, classes: 'tooltip-guide' },
  steps: [
    {
      id: "save-tax-category-tour",
      attachTo: { element: '#btn-save-tax-category-guide', on: 'bottom-start' },
      cancelIcon: {enabled: false},
      title: 'tour_save_assign_tax_category_title',
      text: 'tour_save_assign_tax_category_text',
      parallel: true
     }
   ]
};